import React from 'react'

import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material'

import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import Icon from 'components_new/atoms/Icon'
import IconButton from 'components_new/atoms/IconButton'
import Tooltip from 'components_new/atoms/Tooltip'

import { useEditMode } from 'redux/hooks/DashboardPage'
import { useAllowEditDashboardGroup } from 'redux/hooks/Permissions'

import { DashboardStatus } from 'types/GlobalDashboardGroup'
import { TDashboardGroup } from 'types/GlobalDashboardGroup'

import { TDialogType } from '../index'

interface TopbarActionsProps {
  dashboardGroup: TDashboardGroup | null
  onOpenDialog: (type: TDialogType) => void
  onToggleEditMode: () => void
}

const TopbarActions = (props: TopbarActionsProps) => {
  const { dashboardGroup, onOpenDialog, onToggleEditMode } = props

  const theme = useTheme()
  const showCommonActions = useMediaQuery(theme.breakpoints.up('lg'), {
    noSsr: true
  })
  const editMode = useEditMode()
  const allowEditDashboardGroup = useAllowEditDashboardGroup(dashboardGroup?.id)
  const { t } = useTranslation()

  if (!dashboardGroup) return null

  return (
    <>
      {showCommonActions ? (
        <>
          <Tooltip title={t('global', 'export')}>
            <IconButton onClick={() => onOpenDialog('export_dashboard')}>
              <Icon name="Download" />
            </IconButton>
          </Tooltip>

          {allowEditDashboardGroup ? (
            <>
              <Tooltip
                title={
                  dashboardGroup.status !== DashboardStatus.PUBLISHED
                    ? t('activity_overview', 'drafts_have_no_activity')
                    : t('activity_overview', 'activity_overview')
                }
              >
                <Box>
                  <IconButton
                    onClick={() => onOpenDialog('dashboard_activity')}
                    disabled={
                      dashboardGroup.status !== DashboardStatus.PUBLISHED
                    }
                  >
                    <Icon name="TrendingUpOutlined" />
                  </IconButton>
                </Box>
              </Tooltip>

              <Button
                onClick={onToggleEditMode}
                variant={editMode ? 'contained' : 'text'}
              >
                {editMode ? t('global', 'done') : t('global', 'edit')}
              </Button>
            </>
          ) : null}
        </>
      ) : null}

      {allowEditDashboardGroup ? (
        <Button
          onClick={() => onOpenDialog('share_dashboard')}
          startIcon={<Icon name="Share" />}
          variant="outlined"
          disabled={dashboardGroup.status !== DashboardStatus.PUBLISHED}
        >
          {t('global', 'share')}
        </Button>
      ) : null}
    </>
  )
}

export default TopbarActions
